export default "__VITE_ASSET__DiQyL7IU__"